import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../providers/preferenceProvider';
import '../../css/overlay.css';

const UploadImage = ({ isOpen, onClose, handleSaveImage, image }) => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    setSelectedImage(image);
  }, [image]);

  if (!isOpen) return null;

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
    setImageFile(file);
  };

  return (
    <div className="overlay-backdrop" onClick={onClose}>
      <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
        <div className="overlay-header">Upload Image</div>
        <div className="overlay-admin-form flex flex-col gap-4 p-4">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <img src={selectedImage} alt="Preview" className="w-32 h-32 object-cover rounded-md" />
              <label htmlFor="image-upload" className="cursor-pointer">
                <input type="file" id="image-upload" accept="image/*" onChange={handleImageUpload} />
              </label>
            </div>
          </div>
        </div>
        <div className="flex flex-row-reverse mt-4 gap-2">
          <button className="btn" onClick={() => handleSaveImage(imageFile)} disabled={!imageFile}>
            {t.confirm}
          </button>
          <button className="btn-close" onClick={onClose}>{t.close}</button>
        </div>
      </div>
    </div>
  );
};


export default UploadImage;